import { useIsAuth } from "@shared/hooks/user";
import { root } from "@shared/utils";
import { memo, useState } from "react";
import { useIntl } from "react-intl";
import ModalComponent from "react-modal";
import { Tab, TabList, TabPanel, Tabs } from "react-tabs";

import { SportBetsHistoryList } from "./SportBetsHistoryList";

import "./styles.scss";

interface ISportBetsHistoryModalProps {
  onClose?: () => void;
  isOpen: boolean;
}

export const SportBetsHistoryModal: React.FC<ISportBetsHistoryModalProps> =
  memo(({ isOpen, onClose }) => {
    const intl = useIntl();
    const [isOpenModal, setIsOpenModal] = useState(isOpen);

    const isAuth = useIsAuth();

    const onCloseModal = () => {
      setIsOpenModal(false);
      onClose && onClose();
    };

    return (
      <ModalComponent
        isOpen={isOpenModal && isAuth}
        contentLabel="Sport Bets History Modal"
        overlayClassName="shadow-[0_0_5px_rgba(0,0,0,0.68)] bg-black/80 text-[#474f51] flex justify-center items-center fixed inset-0 z-[100000]"
        className="sport-bets-history-modal bg-white rounded-rounded text-base leading-[1em] flex flex-col px-4 py-3 outline-none max-w-[580px] w-[95%] max-h-[600px] h-full"
        appElement={root as HTMLElement}
        onRequestClose={onCloseModal}
      >
        <div className="flex items-center justify-center relative mb-3 text-center px-4.5">
          <div className="font-bold text-[1.5em] leading-[1.125em] text-theme-color uppercase">
            {intl.formatMessage({
              id: "boilerplate.components.SportBetsHistoryModal.SportBetsHistory",
              defaultMessage: "Sport Bets History",
            })}
          </div>
          <div
            className="flex items-center justify-center absolute right-0 cursor-pointer"
            onClick={onCloseModal}
          >
            <div className="ico ico-close" />
          </div>
        </div>

        <Tabs
          defaultIndex={0}
          className="flex flex-col max-h-full h-full min-h-0"
          selectedTabClassName="[&&]:border-theme-color text-theme-color"
          style={{ width: "100%" }}
        >
          <TabList className="flex justify-center items-center font-bold uppercase text-[0.875em] mb-4 border-b-1 border-[#333]/30 tabset--divide">
            <Tab className="border-0 border-b-2 border-b-transparent border-solid py-3 px-4 cursor-pointer hover:text-theme-color">
              {intl.formatMessage({
                id: "boilerplate.components.SportBetsHistoryModal.InGame",
              })}
            </Tab>

            <Tab className="border-0 border-b-2 border-b-transparent border-solid py-3 px-4 cursor-pointer hover:text-theme-color">
              {intl.formatMessage({
                id: "boilerplate.components.SportBetsHistoryModal.Completed",
              })}
            </Tab>
          </TabList>

          <TabPanel className="overflow-y-auto pb-2 max-h-full min-h-0 h-full empty:hidden">
            <SportBetsHistoryList status="created" />
          </TabPanel>

          <TabPanel className="overflow-y-auto pb-2 max-h-full min-h-0 h-full empty:hidden">
            <SportBetsHistoryList status="non-created" />
          </TabPanel>
        </Tabs>
      </ModalComponent>
    );
  });

SportBetsHistoryModal.displayName = "SportBetsHistoryModal";
